// extracted by mini-css-extract-plugin
export default {"button":"actionsCell_button__zOSuU","labeled":"actionsCell_labeled__EbW2z"};